export default "__VITE_ASSET__pzvV$hSC__"